// Lib
import React from 'react';
import { DropTarget } from 'react-dnd';
import { connect } from 'react-redux';

// Utils
import { inboxDropResultFn } from '../dropResultFn';
import { getNewTransactionId } from '../../../utils/undoRedo/undoRedoTransactionManager';

// Constants
import { ELEMENT_DND_TYPE } from '../../../../common/elements/elementConstants';

// Actions
import { atomicMoveAndUpdate, createElementSync } from '../../actions/elementActions';
import { clearHoverEffect, forceHoverEffect } from '../../../reducers/draggingActions';
import { moveElementsToTrash } from '../../actions/elementShortcutActions';
import { elementSetTempData } from '../../../../common/elements/elementActions';

// Constants
import { TASK_LIST_TYPE } from '../../../../common/taskLists/taskListConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchForceHoverEffect: (effect) => dispatch(forceHoverEffect(effect)),
    dispatchClearHoverEffect: () => dispatch(clearHoverEffect()),
    createTaskList: ({ location, content, transactionId = getNewTransactionId(), sync = true, temp }) => {
        const taskListElementId = dispatch(
            createElementSync({
                elementType: TASK_LIST_TYPE,
                location,
                content,
                sync,
                temp,
                transactionId,
            }),
        );

        return { taskListElementId, transactionId };
    },
    dispatchRevealElement: ({ elementId }) => dispatch(elementSetTempData({ id: elementId, data: { hidden: false } })),
    dispatchMoveElementsToTrash: (props) => dispatch(moveElementsToTrash(props)),
    dispatchAtomicMoveAndUpdate: (props) => dispatch(atomicMoveAndUpdate(props)),
});

const defaultDropCollect = (connector, monitor) => ({
    connectDropTarget: connector.dropTarget(),
    isHovered: monitor.canDrop() && monitor.isOver({ shallow: true }),
    // Note: canDrop was removed from here for performance reasons.
    //  Forcing every element to update on drag was unnecessary and cost a reasonable amount of time
});

// eslint-disable-next-line react/display-name
const injectTargetType = (Element, targetType) => (props) => <Element {...props} targetType={targetType} />;

export default (config = {}, targetType, customCollect) =>
    (Element) => {
        let acceptDropTypes = [ELEMENT_DND_TYPE];

        if (config && config.acceptDropTypes) {
            acceptDropTypes = acceptDropTypes.concat(config.acceptDropTypes);
            delete config.acceptDropTypes;
        }

        const elementDropTarget = { drop: inboxDropResultFn, ...config };

        const dropCollect = customCollect || defaultDropCollect;

        const dropTarget = DropTarget(acceptDropTypes, elementDropTarget, dropCollect)(Element);
        return connect(null, mapDispatchToProps)(injectTargetType(dropTarget, targetType));
    };
